import normalizeSnapshot from '../GSSnapshots/normalizeSnapshot';

export default ({
	primaryEngagementId,
	primaryEngagementDescription: primaryEngagement,
	scopeName: gaScope,
	snapshotModel,
	hashValue = null,
	instructionSetId,
	componentId: componentGuid
}) => {
	const {sections, sentDate} = normalizeSnapshot({
		instructionJson: {...snapshotModel},
		hashValue
	});

	const isGroupRiskAssessmentVisible = snapshotModel?.accounts?.length > 0;

	return {
		instructionSetId,
		primaryEngagementId,
		primaryEngagement,
		gaScope,
		componentGuid,
		sentDate,
		sections,
		isGroupRiskAssessmentVisible,
		accounts: snapshotModel.accounts,
		availableInherentRiskCategories: snapshotModel.availableInherentRiskCategories
	};
};
